module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/clientes/clientes.component.css
// module id = ./src/app/components/clientes/clientes.component.css
// module chunks = main